import * as CL from '@design-system/component-library';
import { t } from '../../common/i18n';

export const ContactDetailsMissingDisclaimer = ({ onClose }: { onClose: () => void }) => (
  <CL.Disclaimer
    title={t.ZKGI(`Check the user's work contact details`)}
    text={t.TA9S('Granting access rights requires a phone number and an email address.')}
    disclaimerType="alert"
    icon={<CL.Icon icon="warning" type="regular" aria-hidden="true" />}
    showCloseButton={true}
    onDisclaimerHide={onClose}
    visible
  />
);
